module.exports = __webpack_public_path__ + "img/logo.15617a22.png";